import { Box, Container, Typography, useTheme } from '@mui/material';

import { MarketingSiteFooter } from './MarketingSiteFooter';

type MarketingPageShellProps = {
  children: React.ReactNode;
  /** Optional hero title (renders top gradient band) */
  title?: string;
  subtitle?: string;
  /** Renders below the subtitle inside the hero band (e.g. diagram) */
  heroAppend?: React.ReactNode;
  /** Show gradient hero band (default true when title provided) */
  showHero?: boolean;
};

export const MarketingPageShell = ({
  children,
  title,
  subtitle,
  heroAppend,
  showHero,
}: MarketingPageShellProps) => {
  const theme = useTheme();
  const heroOn = showHero !== false && Boolean(title);

  return (
    <Box
      sx={{
        minHeight: '100%',
        color: 'text.primary',
        bgcolor:
          theme.palette.background?.default ??
          theme.palette.mainColors.background,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {heroOn && (
        <Box
          sx={{
            pt: { xs: 3, md: 5 },
            pb: { xs: 4, md: 6 },
            background: `linear-gradient(135deg, ${theme.palette.mainColors.background} 0%, ${theme.palette.mainColors.background1} 100%)`,
          }}
        >
          <Container maxWidth="lg">
            <Typography
              variant="h3"
              component="h1"
              sx={{
                fontWeight: 700,
                color: 'text.primary',
                fontSize: { xs: '1.75rem', md: '2.25rem' },
                mb: subtitle ? 1 : 0,
              }}
            >
              {title}
            </Typography>
            {subtitle && (
              <Typography
                variant="h6"
                color="text.secondary"
                sx={{ fontWeight: 400, maxWidth: 720 }}
              >
                {subtitle}
              </Typography>
            )}
            {heroAppend}
          </Container>
        </Box>
      )}
      <Box sx={{ flex: 1, py: { xs: 3, md: 4 } }}>
        <Container maxWidth="lg">{children}</Container>
      </Box>
      <MarketingSiteFooter />
    </Box>
  );
};
